module.exports = __webpack_public_path__ + "7ccd4dc0ae60c4c038816365221a4219.jpg";